<template lang="html">
  <div>
    <b-modal modal-class="modal-cv-templ" ref="modal-cv-info-gral" size="lg" title="Información general" @hidden="$parent.selectedModalCV = null" no-close-on-esc no-close-on-backdrop centered hide-footer>

      <b-form class="px-2" @submit="onSubmit" v-if="showForm">
        <div class="row">

          <b-form-group class="col-md-12 custom-f-group-1" label="Información general sobre ti*" label-for="i-2">
            <editor
               v-model="formCV.cvdescription"
               api-key="voyk5grgw5zv5ueomjptgwscn9vyw7a0sifs0oy5fxj4befk"
               :init="{
                 height: 265,
                 menubar: false,
                 language: 'es_MX',
                 paste_block_drop: false,
                 paste_as_text: !0,
                 entity_encoding: 'raw',
                 plugins: [
                   'advlist autolink lists link image charmap print preview anchor',
                   'searchreplace visualblocks code fullscreen',
                   'insertdatetime media table paste code help wordcount'
                 ],
                 toolbar:
                   'undo redo | formatselect | bold italic backcolor | \
                   alignleft aligncenter alignright alignjustify | \
                   bullist numlist outdent indent | removeformat'
               }"
            />
          </b-form-group>

          <div class="col-12 mt-2">
            <b-form-checkbox
              required
              class="mb-3 custom-checkbox-s1"
              v-model="formCV.check"
              name="checkbox-1"
              value="accepted"
              :unchecked-value="null">
              Al hacer clic en la casilla de verificación, acepta nuestros <router-link to="">Términos y condiciones</router-link> y <router-link to="">Política de privacidad</router-link>
            </b-form-checkbox>

            <b-button type="submit" class="btn-HelvNeu btn-squ-cur-1 btn-send">Actualizar información</b-button>
            <p v-if="saved == true">{{savedmsg}}</p>
          </div>

        </div>
      </b-form>

    </b-modal>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
export default {
  data(){
    return{
      showForm: false,

      formCV: {
        cvdescription: null,
        check: null,
      },
      saved:false,
      savedmsg:null
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
        axios.post(tools.url("/api/admin/updateCv"),this.formCV).then((response)=>{
            this.$root.auth();
            this.savedmsg = 'Información guardada correctamente';
            this.$refs['modal-cv-info-gral'].hide(); // Ocultar modal despues de guardar

            
        }).catch((error)=>{
            alert('Ocurrio un error al guardar la información');

        });
      
      t
    },
  },

  mounted(){
    if(this.$parent.selectedModalCV == 'cv1-informacion'){
      this.formCV.cvdescription = this.$root.user.usercompany.cv;
      this.$refs['modal-cv-info-gral'].show();

      setTimeout( ()=>{
        this.showForm = true;
      }, 500);
    }
  },

  components: {
    'editor': Editor
  },
}
</script>
